import { ANNUAL, MONTHLY } from './Terms';
export const MONTHLY_COMMIT_MONTHLY_PAY = 'MONTHLY_COMMIT_MONTHLY_PAY';
export const ANNUAL_COMMIT_MONTHLY_PAY = 'ANNUAL_COMMIT_MONTHLY_PAY';
export const ANNUAL_COMMIT_ANNUAL_PAY = 'ANNUAL_COMMIT_ANNUAL_PAY';
export const DTBOfferTerms = {
  [MONTHLY_COMMIT_MONTHLY_PAY]: {
    commitment: MONTHLY,
    payment: MONTHLY
  },
  [ANNUAL_COMMIT_MONTHLY_PAY]: {
    commitment: ANNUAL,
    payment: MONTHLY
  },
  [ANNUAL_COMMIT_ANNUAL_PAY]: {
    commitment: ANNUAL,
    payment: ANNUAL
  }
};